import { useState, useEffect, useCallback } from 'react';

// ==============================|| SESSION STORAGE (tab session) ||============================== //

export function useSessionStorage(key, defaultValue) {
  const readValue = () => {
    if (typeof window === 'undefined') return defaultValue;

    try {
      const item = sessionStorage.getItem(key);
      if (!item) return defaultValue;
      const parsed = JSON.parse(item);
      return { ...defaultValue, ...parsed };
    } catch (err) {
      console.warn(`Error reading sessionStorage key "${key}":`, err);
      return defaultValue;
    }
  };

  const [state, setState] = useState(readValue);

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      console.warn(`Error setting sessionStorage key "${key}":`, err);
    }
  }, [key, state]);

  const setField = useCallback((fieldKey, value) => {
    setState((prev) => ({
      ...prev,
      [fieldKey]: value
    }));
  }, []);

  const resetState = useCallback(() => {
    setState(defaultValue);
    try {
      sessionStorage.setItem(key, JSON.stringify(defaultValue));
    } catch {
      // ignore
    }
  }, [defaultValue, key]);

  return { state, setState, setField, resetState };
}
